import { Component } from '@angular/core';

@Component({
  selector: 'op-exchange-rate-amount',
  templateUrl: './exchange-rate-amount.component.html'
})
export class ExchangeRateAmountComponent {
}
